import { render, staticRenderFns } from "./SearchSuggestions.vue?vue&type=template&id=e950a314&scoped=true&"
import script from "./SearchSuggestions.vue?vue&type=script&lang=js&"
export * from "./SearchSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./SearchSuggestions.vue?vue&type=style&index=0&id=e950a314&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e950a314",
  null
  
)

export default component.exports